import { Controller, Control, FieldErrors } from "react-hook-form";
import ErrorAlert from "shared/UI/Alerts/ErrorAlert";
import { useTranslation } from "react-i18next";
import { Inputs } from "../Communications";
import { Input } from "shared/UI/Input/Input";
import { Select } from "shared/UI/Select/Select";
import { communicationEmailGroups } from "shared/constants/Modules";

export const Emails = ({ control, errors }: { control: Control<Inputs, any>; errors: FieldErrors<Inputs> }) => {
  const { t } = useTranslation();

  return (
    <>
      <div>
        <Controller
          name={"emailGroupId"}
          control={control}
          rules={{
            required: true,
          }}
          render={({ field: { onChange, value } }) => (
            <>
              <Select
                id="email-group"
                label={t("communications.email.emailGroupLabel")}
                aria-label={t("communications.email.emailGroupLabel")}
                onChange={onChange}
                value={value}
                placeholder={t("communications.email.emailGroupPlaceholder")}
              >
                <option value={communicationEmailGroups.PRODUCT_UPDATES}>{t("communications.email.emailGroupOptions.productUpdates")}</option>
                <option value={communicationEmailGroups.PERKS_AND_DISCOUNTS}>{t("communications.email.emailGroupOptions.perksAndDiscounts")}</option>
              </Select>
              {errors.emailGroupId && <ErrorAlert content={t("communications.email.emailGroupErrorMessage")} />}
            </>
          )}
        />
      </div>
      <div>
        <Controller
          name={"templateId"}
          control={control}
          rules={{
            required: true,
          }}
          render={({ field: { onChange, value } }) => (
            <>
              <Input
                type="text"
                id="title"
                label={t("communications.email.templateLabel")}
                aria-label={t("communications.email.templatePlaceholder")}
                onChange={onChange}
                value={value}
                autoComplete="disabled"
                placeholder={t("communications.email.templatePlaceholder")}
              />
              {errors.templateId && <ErrorAlert content={t("communications.email.templateErrorMessage")} />}
            </>
          )}
        />
      </div>
    </>
  );
};
